import { type RouteRecordRaw } from 'vue-router'

export const launchRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/LaunchDashboardView.vue'),
    meta: {
      authZ: ({ user }) => user.hasRole('pb:super'),
      title: 'launch.dashboard',
    },
    name: 'brand.launch',
    path: 'launch',
  },
]
